import { render, staticRenderFns } from "./userPicker.vue?vue&type=template&id=631edf1b&scoped=true&"
import script from "./userPicker.vue?vue&type=script&lang=js&"
export * from "./userPicker.vue?vue&type=script&lang=js&"
import style0 from "./userPicker.vue?vue&type=style&index=0&id=631edf1b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631edf1b",
  null
  
)

export default component.exports